import { Modal, Button } from "antd";
import React from "react";
import "./PopUpLogIn.css";

const PopUpLogIn = ({ isOpen, onLoginRegister, onContinue }) => {
  return (
    <Modal
      className="login-popup"
      title="Zaloguj się, żeby mieć wgląd do Twoich przyszłych wizyt"
      open={isOpen}
      footer={null}
      closable={false}
      centered
    >
      <div className="popup-buttons">
        <Button 
          type="primary" 
          className="custom-ok-btn" 
          onClick={onLoginRegister}
          block
        >
          Zaloguj / Zarejestruj się
        </Button>
        <Button 
          className="custom-cancel-btn" 
          onClick={onContinue}
          block
        >
          Kontynuuj bez rejestracji
        </Button>
      </div>
    </Modal>
  );
};

export default PopUpLogIn;